import { TrackJS } from 'trackjs';
import { TrackJSConfig } from '../../../../models/utils/trackjs.interfaces';
import { TrackJsConfigService } from '../track-js-config.service';

export function installTrackJS(trackJSConfigService: TrackJsConfigService) {
  return async () => {
    const [env]: TrackJSConfig[] = trackJSConfigService
      .getTrackJsConfig()
      .filter(({ name }) => name === document.location.hostname)
      .map((config: TrackJSConfig) => {
        delete config.name;
        return config;
      });
    await TrackJS.install(env);
  };
}
